import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';

export const loadEvents = () => {
    return (dispatch) => {

	return customRequest(actions.events.index, {}).then((res) => {
	    return dispatch({ type: actions.events.index.status.success, data: res});
	})
    }
}

export const saveEvent = (data) => {

    return (dispatch) => {	   
	return customRequest(actions.events.create, {event: data})
    }
}

export const showEvent = (id) => {
    return (dispatch) => {
	dispatch({ type: actions.events.show.status.request, data: {}})
	return customRequest(actions.events.show,  {id: id}).then((res) => {
	    dispatch({ type: actions.events.show.status.success, data: res});
	})
    }
}
export const clearEvent = (id) => {
    return (dispatch) => {
	dispatch({ type: actions.events.show.status.request, data: {}})
    }
}


export const updateEvent = (data) => {

    return (dispatch) => {
		   
	return customRequest(actions.events.update, {id: data.id, event: data})
    }
}
export const removeEvent = (data) => {

    return (dispatch) => {
		   
	return customRequest(actions.events.delete,  data)
    }
}




// WEBPACK FOOTER //
// ./src/actions/Events.js